export enum Flag {
	// --- Test Flags ---
	TestFlagTrue = "TEST_FLAG_TRUE",
	TestFlagFalse = "TEST_FLAG_FALSE",

	// --- Feature Flags ---
	CanvasLayoutVisualDebug = "CANVAS_LAYOUT_VISUAL_DEBUGGING",
	GitBranching = "GIT_BRANCHING",
	DisplayMarkdownEditor = "DISPLAY_MARKDOWN_EDITOR",

	ShareTab = "SHARE_TAB",

	CollabEditing = "COLLAB_EDITING",

	MultiColumn = "MULTI_COLUMN",

	EnableDocumentAttachments = "ENABLE_DOCUMENT_ATTACHMENTS",
	Workflows = "WORKFLOWS",
	WorkspaceSecrets = "WORKSPACE_SECRETS",
}

export const defaultFlags: Record<Flag, boolean> = {
	[Flag.TestFlagTrue]: true,
	[Flag.TestFlagFalse]: false,
	[Flag.CanvasLayoutVisualDebug]: false,
	[Flag.GitBranching]: false,
	[Flag.DisplayMarkdownEditor]: false,
	[Flag.ShareTab]: false,
	[Flag.CollabEditing]: false,
	[Flag.MultiColumn]: false,
	[Flag.EnableDocumentAttachments]: false,
	[Flag.Workflows]: true,
	[Flag.WorkspaceSecrets]: false,
};
